import { useEffect } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingWolf } from '@rtkwlf/fenrir-react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useScannerProfile } from '@apis/rendall/queries/use-scanner-profile';
import { Stack } from '@packages/fenrir/components/stack';

import { scannerInformationDefault } from '../scanners-config/components/default-form-state';

import { ScannerInformationForm } from './scanner-information-form';
import { transformToScannerDetailsForm } from './transform-to-scanner-details-form.tsx';
import { useScannerDetailsValidationSchema } from './use-scanner-details-validation-schema/use-scanner-details-validation-schema';

const ScannerInformationPage: React.FC = () => {
  const { scannerId = '' } = useParams();
  const { t } = useTranslation('ui');

  const { data: scannerProfile, isPending } = useScannerProfile(scannerId);

  const validationSchema = useScannerDetailsValidationSchema();

  const formMethods = useForm({
    defaultValues: scannerInformationDefault,
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (scannerProfile) {
      const transformedForm = transformToScannerDetailsForm(scannerProfile);
      formMethods.reset(transformedForm);
    }
  }, [formMethods, scannerProfile]);

  return isPending || !scannerProfile ? (
    <Stack
      width="100%"
      justifyContent="center"
      alignContent="center"
      height="60vh"
    >
      <LoadingWolf isLoading caption={t('loader.caption')} />
    </Stack>
  ) : (
    <FormProvider {...formMethods}>
      <ScannerInformationForm scannerProfile={scannerProfile} />
    </FormProvider>
  );
};

export default ScannerInformationPage;

export const Component = () => <ScannerInformationPage />;
